import { c as _c } from "react/compiler-runtime";
import { Box, Tooltip } from '@mui/material';
import type { JobStatus } from '@repo/api-gw-sdk';
import React from 'react';
import { JobStatuses } from '@/data/inventory/jobStatuses';
export interface JobStatusIconProps {
  jobStatus: JobStatus;
  onClick?: () => void;
  isStatic?: boolean;
  hideTooltip?: boolean;
  presentation?: (typeof JobStatuses)[JobStatus];
}
export const JobStatusIcon = React.forwardRef((t0, ref) => {
  const $ = _c(15);
  const {
    jobStatus,
    onClick,
    isStatic,
    hideTooltip,
    presentation
  } = t0;
  const data = presentation ?? JobStatuses[jobStatus];
  if (!data) {
    return null;
  }
  const t1 = hideTooltip ? undefined : data.title;
  let t2;
  if ($[0] !== data.iconColor) {
    t2 = {
      background: data.iconColor
    };
    $[0] = data.iconColor;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data.backgroundColor || $[3] !== t2) {
    t3 = {
      background: data.backgroundColor,
      "& i": t2
    };
    $[2] = data.backgroundColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${isStatic && data.staticIcon ? data.staticIcon : data.icon} h-[20px] w-[20px]`;
  let t5;
  if ($[5] !== t4) {
    t5 = <i className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onClick || $[8] !== ref || $[9] !== t3 || $[10] !== t5) {
    t6 = <Box ref={ref} onClick={onClick} component="span" className="rounded-full inline-flex p-[2px]" sx={t3}>{t5}</Box>;
    $[7] = onClick;
    $[8] = ref;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <Tooltip title={t1}>{t6}</Tooltip>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
});